module.exports = __webpack_public_path__ + "img/creditcard_tr.88f64782.svg";